import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权

const whiteList = ['/login', '/scholarship/apply', '/scholarship/thanks'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => { // 拉取用户信息
          let menus=res.data.menus;
          let username=res.data.username;
          let roles=res.data.roles;
          let firstRoute = null;
          store.dispatch('GenerateRoutes', { menus,username,roles }).then(() => { // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            //跳转到第一个有权限的页面（因为只跳到父节点，需要查看children中第一个有权限的页面）
            firstRoute = store.getters.addRouters[0];
            if(firstRoute.children && firstRoute.children.length > 0) {
              firstRoute = firstRoute.children[0];
            }
            // console.log("测试", firstRoute, to)
            let redirectTo = to["fullPath"] == "/tasks/task" || to["fullPath"] == "/" ? firstRoute : to;
        
            // next({...to, replace: true})
            // console.log("redirectTo", redirectTo)
            next({ ...redirectTo, replace: true })
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/permission.js